import { CoreSkeleton } from "./CoreSkeleton.tsx";

interface Props {
  size: number;
}

export const CoreLoading: React.FC<Props> = ({ size }) => {
  return (
    <>
      {Array(size)
        .fill(0)
        .map((_, index) => (
          <CoreSkeleton key={index} />
        ))}
    </>
  );
};
